export default __webpack_public_path__ + "static/media/libro.c4725e7f.png";